"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeArgumentError = exports.BeeError = void 0;
class BeeError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.BeeError = BeeError;
class BeeArgumentError extends BeeError {
    constructor(message, value) {
        super(message);
        this.value = value;
    }
}
exports.BeeArgumentError = BeeArgumentError;
